import React from 'react';
import {HashLink} from 'react-router-hash-link';

import './AboutLink.css'

class AboutLink extends React.Component {
  render(): JSX.Element {
    return (
      <HashLink
        className="about-link"
        to="/about">
        о нас
      </HashLink>
    );
  }
}

export default AboutLink;
